// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setExportOption = createAction('[Custom PDF Report Modal] Set export option', props());
